<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-sm-4">
        <h1 class="text-center font-weight-bold">VERIFIKASI</h1>
        <p for class="text-center font-weight-bold">
          Masukan kode verifikasi yang dikirim via SMS
          <br />ke {{ logInPhone }}
        </p>
        <div class="row phone-verify">
          <div class="col-2">
            <input v-model="otpCode.first" id="input1" class="inputs" type="text" maxLength="1" size="1" min="0" max="9" />
          </div>
          <div class="col-2">
            <input v-model="otpCode.second" id="input2" class="inputs" type="text" maxLength="1" size="1" min="0" max="9" />
          </div>
          <div class="col-2">
            <input v-model="otpCode.third" id="input3" class="inputs" type="text" maxLength="1" size="1" min="0" max="9" />
          </div>
          <div class="col-2">
            <input v-model="otpCode.fourth" id="input4" class="inputs" type="text" maxLength="1" size="1" min="0" max="9" />
          </div>
          <div class="col-2">
            <input v-model="otpCode.fifth" id="input5" class="inputs" type="text" maxLength="1" size="1" min="0" max="9" />
          </div>
          <div class="col-2">
            <input v-model="otpCode.sixth" id="input6" class="inputs" type="text" maxLength="1" size="1" min="0" max="9" />
          </div>
        </div>
        <div class="text-center mt-4">
          <button
            @click="verifyPhone"
            type="submit"
            class="btn btn-success"
            style="width: 30%;
              border-radius: 17px;"
          >VERIFIKASI</button>
          <div class="text-danger text-center">{{ error }}</div>
          
        </div>
        <div class="text-center mt-3">
          <div class="text-danger text-center">
            <span v-if="!showResendCode">Kirim ulang kode verifikasi dapat dilakukan dalam {{ timeLeft }} detik</span>
            <button v-on:click="resendCode" v-if="showResendCode" class="btn btn-link">KIRIM ULANG</button>
          </div>
        </div>
      </div>
      <div class="col-sm-4"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      otpCode: {
        first: '',
        second: '',
        third: '',
        fourth: '',
        fifth: '',
        sixth: '',
      },
      timeLeft: 0,
      showResendCode: false
    }
  },
  computed: {
    ...mapState('account', ['logInPhone', 'isCountdown', 'error'])
  },
  created() {
    this.checkIsPhoneExist()
    this.countdown()
  },
  methods: {
    ...mapActions('account', ['loginPhoneOtp', 'phoneResendVerification']),
    checkIsPhoneExist() {
      if(!this.logInPhone) {
        this.$router.push('login')
      }
    },
    verifyPhone() {
      let phone = this.logInPhone
      let objValues = Object.values(this.otpCode)
      let otpCode = objValues.join('')
      this.loginPhoneOtp({ phone, otpCode })
    },
    resendCode() {
      this.phoneResendVerification(this.logInPhone)
      this.timeLeft = 30
      this.showResendCode = false
    },
    countdown() {
      let self = this
      self.timeLeft = 30
      this.intervalid = setInterval(function(){
        if(self.timeLeft > 0) {
          self.timeLeft -= 1
        } else {
          self.showResendCode = true
        }
      }, 1000);
    }
  },
  mounted() {
    $('#input1').focus();
    $(".inputs").keyup(function () {
      if (this.value.length == this.maxLength) {
        let inputId = $(this).attr("id");
        let nextId = Number(inputId.slice(-1)) + 1

        $('#input'+nextId).focus();
      }
    });
  }
};
</script>

<style>
.phone-verify input {
    width: 60px;
    height: 65px;
    font-size: 34px;
    text-align: center;
    border: none;
    border-bottom: 4px solid;
    outline: none;
}

.phone-verify input[type=number]::-webkit-inner-spin-button, 
.phone-verify input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>